import Image from 'next/image';

import { Container } from '@/atoms';

import LogoMobile from '@/assets/images/logo-bg-mobile.png';
import Logo from '@/assets/images/logo-bg.png';

import type { FunctionComponent } from 'react';
import type { TypeHeroProps } from './types';

export const Hero: FunctionComponent<TypeHeroProps> = ({
  className = '',
  classNameWrapper = '',
  backgroundImage,
  backgroundTop,
  backgroundColor,
  backgroundVideo,
  children,
  overlay,
  justify,
  textAlign,
  align,
  minHeight,
  backgroundBottom,
  notLazy = true,
  style,
  variant = 'default',
  hideLogo = false,
}: TypeHeroProps) => (
  <div className="relative">
    <Container
      wrapper
      className={`py-(--hero-py-mobile)! md:py-(--hero-py-desktop)! ${variant === 'blog' ? 'min-h-[385px] md:h-[450px] lg:h-[400px]' : ''} ${className} `}
      classNameWrapper={classNameWrapper}
      backgroundImage={backgroundImage}
      backgroundColor={backgroundColor}
      backgroundVideo={backgroundVideo}
      justify={justify}
      align={align}
      textAlign={textAlign}
      overlay={overlay}
      backgroundTop={backgroundTop}
      backgroundBottom={backgroundBottom}
      backgroundLazy={notLazy}
      style={{
        ...style,
        ...(minHeight && {
          minHeight: `${minHeight}px`,
        }),
      }}
    >
      {children}
    </Container>

    {variant === 'blog' && !hideLogo && (
      <>
        <Image
          src={Logo}
          width="1080"
          height="1080"
          alt="Logo Blog"
          className="absolute top-1/2 bottom-0 left-1/2 hidden lg:block 2xl:right-0 2xl:left-[unset]"
        />
        <Image
          src={LogoMobile}
          width="400"
          height="400"
          alt="Logo Blog Mobile"
          className="absolute right-0 bottom-0 left-0 lg:hidden"
        />
      </>
    )}
  </div>
);

Hero.displayName = 'Hero';
